const redirectFromIframe = () => {
  if (window && window.frameElement) {
    window.addEventListener('load', function() {
      window.top.location.href = window.location.href;
    });
  }
};

export default redirectFromIframe;
